import { holidayCalendarConfig, Holiday } from '@/src/constants/holidayCalendarConfig'
import { domainCountry } from '@/src/constants/domain'

/**
 * Maps domain country code to config key
 * FSA -> fsa, FAE -> fae, FEG -> egy
 */
const getDomainKey = (domain: string): string => {
    const domainMap: { [key: string]: string } = {
        FSA: 'fsa',
        FAE: 'fae',
        FEG: 'egy'
    }
    return domainMap[domain] || 'fsa' // Default to fsa if not found
}

/**
 * Gets holiday config for current domain and locale
 * @param locale - Locale code ('en' or 'ar')
 * @returns Array of holidays for the domain and locale, or empty array if not found
 */
export const getHolidayConfig = (locale: string = 'en'): Holiday[] => {
    const domain = domainCountry
    const domainKey = getDomainKey(domain)
    const localeKey = (locale === 'ar' ? 'ar' : 'en') as 'en' | 'ar'

    const config = holidayCalendarConfig[domainKey]
    if (!config) {
        return []
    }

    return config[localeKey] || []
}

